import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function AtlasFAQ() {
  const { t, messages } = useI18n();
  const items = messages?.faq?.items || [];
  return (
    <section
      id="preguntas-clave"
      data-testid="atlas-faq"
      className="py-16 lg:py-24 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-[#6B46C1] uppercase tracking-[0.18em] text-xs font-bold">
          <HelpCircle size={14} />
          <span>{t("faq.badge")}</span>
        </div>
        <h2
          data-testid="faq-title"
          className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] leading-tight font-extrabold text-slate-900"
        >
          {t("faq.titleA")}{" "}
          <span className="text-[#6B46C1]">{t("faq.titleB")}</span>
        </h2>
        <p className="mt-3 text-slate-600 text-base sm:text-lg max-w-2xl">
          {t("faq.subtitle")}
        </p>

        <Accordion
          type="single"
          collapsible
          className="mt-10 space-y-3"
          data-testid="faq-accordion"
        >
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-slate-200 bg-white px-5 transition-shadow data-[state=open]:shadow-md data-[state=open]:border-[#6B46C1]/40"
            >
              <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-slate-900 hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-700 text-[15px] leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
